'use client'

import {
  DiscordLogoIcon,
  HeadlineText,
  XLogoIcon,
  YoutubeLogoIcon,
  FarcasterLogoIcon,
  InstagramLogoIcon,
  DetailText
} from 'design-configuration/components'
import NewsletterSignup from './newsletter-form'
import Link from 'next/link'
import { ArtblocksLockupLogo } from 'design-configuration/components/icons'
import { usePathname } from 'next/navigation'

const FOOTER_HIDDEN_PATHS = [
  '/collection/(.*)/purchase',
  '/token/0x[a-fA-F0-9]{40}/([0-9]+)$',
  '/profile/(.*)',
  '/timeline'
]

const Footer = (): React.ReactElement | null => {
  const pathname = usePathname()
  const isHidden = FOOTER_HIDDEN_PATHS.some((path) => RegExp(path).test(pathname))

  if (isHidden) {
    return null
  }

  return (
    <footer className="px-md pt-2xl bg-surface-inverted relative pb-14 text-white">
      <div className="gap-md flex flex-col justify-between sm:flex-row">
        <div className="gap-md flex flex-col">
          <ArtblocksLockupLogo className="fill-on-surface-inverted h-[40px]" />
          <HeadlineText className="font-light">The premier destination for generative art.</HeadlineText>
          <NewsletterSignup />
        </div>
        <div className="flex flex-col sm:items-end">
          <div className="gap-md flex h-full flex-col sm:justify-end">
            <div className="gap-md flex w-full flex-row sm:justify-end">
              {[
                {
                  icon: <XLogoIcon className="fill-on-surface-inverted h-md w-md" />,
                  href: 'https://twitter.com/artblocks_io'
                },
                {
                  icon: <DiscordLogoIcon className="fill-on-surface-inverted h-md w-md" />,
                  href: 'https://discord.com/invite/artblocks'
                },
                {
                  icon: <FarcasterLogoIcon className="fill-on-surface-inverted h-md w-md" />,
                  href: 'https://warpcast.com/artblocks'
                },
                {
                  icon: <YoutubeLogoIcon className="fill-on-surface-inverted h-md w-md" />,
                  href: 'https://www.youtube.com/channel/UCJ3do9nWP6qaJkcbxZaJZ4w'
                },
                {
                  icon: <InstagramLogoIcon className="fill-on-surface-inverted h-md w-md" />,
                  href: 'https://www.instagram.com/artblocks_io'
                }
              ].map(({ icon, href }) => (
                <Link href={href} key={href} target="_blank">
                  {icon}
                </Link>
              ))}
            </div>
            <div className="gap-md text-on-surface-inverted-variant flex w-full flex-wrap font-medium uppercase sm:justify-end">
              <Link href="/privacy-policy.pdf" target="_blank">
                <DetailText className="whitespace-nowrap">Privacy Policy</DetailText>
              </Link>
              <Link href="/user-terms.pdf" target="_blank">
                <DetailText className="whitespace-nowrap">User Terms</DetailText>
              </Link>
              <DetailText className="whitespace-nowrap">© {new Date().getFullYear()} ART BLOCKS, INC.</DetailText>
            </div>
          </div>
        </div>
      </div>
      <div
        className="h-xs bg-surface-inverted absolute bottom-0 left-0 right-0"
        style={{
          background:
            'linear-gradient(270deg, #03FD00 0.9%, #01FDFD 20.72%, #1500FC 40.54%, #FD02FD 60.36%, #FD0001 80.18%, #FDE000 100%)'
        }}
      />
    </footer>
  )
}

export default Footer
